<template>

  <el-dialog :show-close="true" title="消息推送" :visible="dialogVisible" @close="bntClick(null)">
    <el-col>
      <el-form>
        <el-col :span="10">
          <el-form-item label-width="90px" label="消息类型:" required>
            <el-select v-model="messageType" placeholder="请选择">
              <el-option
                  v-for="item in messageTypes"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>

      <el-input
          v-show="messageType==='S_CUSTOM'"
          style="margin-top: 10px;margin-bottom: 20px;margin-left: 10px;"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5}"
          placeholder="请输入内容"
          v-model="messageContent">
      </el-input>

    </el-col>

    <div slot="footer" class="dialog-footer">
      <el-button @click="bntClick(null)">取 消</el-button>
      <el-button type="primary" @click="bntClick('Push',messageContent)">立即推送</el-button>
    </div>
  </el-dialog>

</template>

<script>

import toastUtils from "@/utils/toastUtils";

export default {
  name: "pushMessageDialog",
  //完整接收props参数
  props: {
    dialogVisible: {
      type: Boolean,
      default: false //默认值
      // required:true //是必要的
    },
  },
  methods: {
    bntClick(btnType, value) {
      ///btnType === null表示取消和关闭按钮
      if (btnType === null) {
        this.$emit('pushClick', null, null)
        return;
      }
      if (!this.messageType) {
        toastUtils.warning(this, "消息类型不能为空")
        return;
      }

      if (this.messageType === "S_CUSTOM" && !value) {
        toastUtils.warning(this, "自定义消息内容不能为空")
        return;
      }
      if (this.messageType === "S_GPS") {
        value = "GPS上传"
      }
      this.$emit('pushClick', value, this.messageType)
    }
  },
  data() {
    return {
      messageTypes: [
        {name: "GPS上传", value: "S_GPS"},
        {name: "自定义消息", value: "S_CUSTOM"},
      ],
      messageType: 'S_CUSTOM',
      messageContent: null
    }
  },
}
</script>

<style scoped>

</style>